import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class MyExportsDialogService {
    private dialogRef: DynamicDialogRef | null = null;
    private triggerElement: HTMLElement | null = null;

    constructor (
        private readonly dialogService: DialogService,
        private readonly translocoService: TranslocoService,
    ) {}

    async open (): Promise<DynamicDialogRef> {
        if (this.dialogRef) {
            this.dialogRef.close();
        }

        this.triggerElement = (document.activeElement instanceof HTMLElement) ? document.activeElement : null;

        const { MyExportsDialogComponent } = await import('@client/app/shared-modules/my-exports/components/my-exports-dialog/my-exports-dialog.component');

        this.dialogRef = this.dialogService.open(MyExportsDialogComponent, {
            header: this.translocoService.translate('myExports.dialog.header'),
            width: '90vw',
            style: { 'max-width': '900px' },
            modal: true,
            closable: true,
            dismissableMask: true,
            resizable: false,
            draggable: false,
            baseZIndex: 10000,
        });

        this.dialogRef.onClose.subscribe(() => {
            this.triggerElement?.focus();
            this.triggerElement = null;
            this.dialogRef = null;
        });

        return this.dialogRef;
    }

    close (): void {
        if (this.dialogRef) {
            this.dialogRef.close();
            this.dialogRef = null;
        }
    }
}
